import { useTranslation } from "react-i18next";
import { ConfirmationModal } from "../../ConfirmationModal";
import { TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";

interface Props {
    info: {
        show: boolean;
        automation?: any;
    };
    onClose: () => void;
    deactivateAutomation: (automation: any) => void
}

export const DeactivateClientAutomationModal: React.FC<Props> = ({
    info,
    onClose,
    deactivateAutomation
}) => {

    const { t } = useTranslation();

    const onDeactivateAutomation = () => {
        deactivateAutomation(info.automation!)
        onClose();
    };

    return(
        <ConfirmationModal 
            label={t("DEACTIVATE_AUTOMATION")}
            isDeleteConfirm={true}
            isOpen={info.show}
            onClose={onClose}
            cancelButton={{ label: t("CLOSE"), icon: <XMarkIcon />, onClick: onClose, }}
            saveButton={{ label: t("DEACTIVATE"), icon: <TrashIcon />, onClick: onDeactivateAutomation }}
        >
            <div className='w-full flex flex-wrap items-center justify-center'>
                <label className="text-lg font-semibold py-4 px-2 text-center">
                    {t('DEACTIVATE_AUTOMATION_MESSAGE')}
                </label>
            </div>
        </ConfirmationModal>
    )
}